
import { BadRequestException } from '../services/exceptions';
import { get, post } from './http'

export async function saveCheckboxes(checkboxes) {
  // console.log('CheckboxesApi saveCheckboxes props.checkboxes:', checkboxes)
  const json = JSON.stringify(checkboxes)

 const response = await post(`/users/saveCheckboxes/${json}`)

  if (response.status === 200)
    return await response.json()

  throw new BadRequestException('Unknown error occured on saveCheckboxes')
}

export async function getCheckboxes() {
  // console.log('CheckboxesApi getCheckboxes props:', props)
  const response = await get(`/users/getCheckboxes/`)

  if (response.status === 200)
    return await response.json()

  throw new BadRequestException('Unknown error occured on getCheckboxes')
}